import { Suspense } from "react"
import RecurringDonationsList from "../../planned_giving/RecurringDonationsList"
import { Loading } from "source/giving/donate/form/components/Loading"
import PledgesList from "../../planned_giving/PledgesList"

export default function PlannedGivingSummary() {
  return (
    <>
      <Suspense fallback={<Loading />}>
        <RecurringDonationsList showFullDetails={false} />
      </Suspense>
      <Suspense fallback={<Loading />}>
        <PledgesList showFullDetails={false} />
      </Suspense>
    </>
  )
}
